import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCreateWedding = loadable(() => import(/* webpackChunkName: "content/createwedding" */ '.'));
